'use client';

import { Link, usePathname } from '@/i18n/routing';
import { signOut } from '@/lib/auth-client';
import { 
  Users, 
  Briefcase, 
  FileText, 
  Target, 
  Settings, 
  LogOut, 
  LayoutDashboard,
  Mail,
  Quote,
  Layers,
  BookOpen
} from 'lucide-react';

const menuItems = [
  { label: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { label: 'Panduan CMS', href: '/admin/guide', icon: BookOpen },
  { label: 'Messages', href: '/admin/messages', icon: Mail },
  { label: 'Testimonials', href: '/admin/testimonials', icon: Quote },
  { label: 'Our People', href: '/admin/people', icon: Users },
  { label: 'Services', href: '/admin/services', icon: Target },
  { label: 'Service Categories', href: '/admin/services/categories', icon: Layers },
  { label: 'Insights', href: '/admin/insights', icon: FileText },
  { label: 'Careers', href: '/admin/careers', icon: Briefcase },
  { label: 'Footprints / Industry', href: '/admin/footprints', icon: Target },
  { label: 'About Us Settings', href: '/admin/about-settings', icon: Settings },
  { label: 'Settings', href: '/admin/settings', icon: Settings },
];

export function Sidebar() {
  const pathname = usePathname();

  return (
    <aside className="w-64 bg-navy text-white flex flex-col">
      <div className="p-6">
        <Link href="/" className="text-xl font-bold tracking-wider">
          SIMISI <span className="text-primary">CMS</span>
        </Link>
      </div>
      
      <nav className="flex-1 px-4 py-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = pathname === item.href;
          
          return (
            <Link
              key={item.href}
              href={item.href as any}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? 'bg-primary text-navy' 
                  : 'hover:bg-white/10 text-gray-300 hover:text-white'
              }`}
            >
              <Icon size={20} />
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-white/10">
        <button
          onClick={() => signOut({ callbackUrl: '/' })}
          className="flex items-center gap-3 w-full px-4 py-3 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
        >
          <LogOut size={20} />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </aside>
  );
}
